module.exports = require("@koishijs/assets");